import axios, { AxiosResponse } from 'axios'
import { BACKEND_URL_STORE } from '@constants/server.constant'
import { IPublicHoliday } from '@common/interface/public-holiday'

export const listPublicHolidays = (): Promise<
  AxiosResponse<IPublicHoliday[], any> | undefined
> => axios.get(`${BACKEND_URL_STORE}/public-holiday`)
